const isServiceWorkerSupported = () =>
  window.isSecureContext && 'serviceWorker' in navigator;

const getServiceWorkerRegistration = async () => {
  if (!isServiceWorkerSupported()) return null;
  return navigator.serviceWorker.getRegistration('/');
};

const registerServiceWorker = async () => {
  if (!isServiceWorkerSupported()) return null;
  try {
    const existing = await navigator.serviceWorker.getRegistration('/');
    if (existing) return existing;
    return await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  } catch (error) {
    const message = `${error?.message ?? ''}`.toLowerCase();
    if (error?.name === 'AbortError' || message.includes('storage error')) {
      console.warn('Push notifications unavailable: browser storage not accessible.', error);
      return null;
    }
    console.error('Service worker registration error:', error);
    return null;
  }
};

const unregisterServiceWorker = async () => {
  const registration = await getServiceWorkerRegistration();
  if (!registration) return false;
  return registration.unregister();
};

export {
  isServiceWorkerSupported,
  getServiceWorkerRegistration,
  registerServiceWorker,
  unregisterServiceWorker,
};
